export interface Author {
  id: string;
  name: string;
  role: string;
  /** Initials shown in the byline / bio avatar. */
  initials: string;
  bio: string;
}

/**
 * Author registry. Posts reference an author by the keys below (the `author`
 * field in their frontmatter). To add a writer, add an entry here once and
 * reference its key from any number of posts.
 */
export const AUTHORS: Record<string, Author> = {
  alain: {
    id: 'alain',
    name: 'Alain Readman',
    role: 'Co-founder, Revvly',
    initials: 'AR',
    bio: 'Alain spent a decade building and scaling subscription businesses before founding Revvly. He writes about the infrastructure gap between what SaaS companies report and what they actually earn.',
  },
  samuel: {
    id: 'samuel',
    name: 'Samuel Adeyemo',
    role: 'Revenue Systems, Revvly',
    initials: 'SA',
    bio: 'Samuel builds the systems that turn billing events into trustworthy revenue numbers. He writes about retention, pricing, and the operational details that decide whether the metrics hold up.',
  },
};

const FALLBACK: Author = {
  id: 'unknown',
  name: 'Revvly',
  role: 'Revvly',
  initials: 'R',
  bio: '',
};

/** Resolve an author id to its record, falling back to a safe default. */
export function getAuthor(id: string): Author {
  return AUTHORS[id] ?? { ...FALLBACK, id };
}
